import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  Locale,
  compareLocale,
  dateLocale,
  getLocale,
  setLocale,
  subscribeLocale,
  t,
} from "../i18n/locale";

interface LocaleContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: typeof t;
  dateLocale: typeof dateLocale;
  compareLocale: typeof compareLocale;
}

const LocaleContext = createContext<LocaleContextValue | null>(null);

export function LocaleProvider({ children }: { children: React.ReactNode }) {
  const [locale, setLocaleState] = useState<Locale>(getLocale);

  useEffect(() => subscribeLocale(() => setLocaleState(getLocale())), []);

  const value = useMemo<LocaleContextValue>(
    () => ({
      locale,
      setLocale,
      t,
      dateLocale,
      compareLocale,
    }),
    [locale]
  );

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale(): LocaleContextValue {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error("useLocale must be used within LocaleProvider");
  return ctx;
}
